__turbopack_context__.v({
  "className": "tMYsjG_className",
});
